// Structure of the global settings:
// app/views/shared/_global_settings.slim

const structure = {
  permissions: {
    dataset: 'permissions',
    default: {},
  },
  currentUser: {
    dataset: 'currentUser',
    default: {},
  },
  availableCohorts: {
    dataset: 'availableCohorts',
    default: {},
  },
  availableCohortsSegments: {
    dataset: 'availableCohortsSegments',
    default: {},
  },
  advancedMetrics: {
    dataset: 'advancedMetrics',
    default: {},
  },
  advancedMetricsV2: {
    dataset: 'advancedMetricsV2',
    default: {},
  },
};

const getRootNode = () => document.getElementById('global-settings');

const parseSettings = (dataset = {}) => Object.keys(structure).reduce((acc, key) => ({
  ...acc,
  [key]: JSON.parse(dataset[structure[key].dataset] || JSON.stringify(structure[key].default)),
}), {});

export const getGlobalSettings = () => {
  const rootNode = getRootNode();

  if (!rootNode) return parseSettings({});

  return parseSettings(rootNode.dataset);
};
